<template>
  <div>
    <div class="row">
      <div class="col text-right">
        <button class="btn btn-sm btn-secondary"
                @click="showModalLog()">
          <icon-svg icon="add"
                    class="icon--xs icons--white mr-1" />
          Novo andamento
        </button>
      </div>
    </div>
    <b-table :fields="table.fields"
             :items="protocolo.logs"
             outlined
             striped
             :busy="table.busy"
             class="text-center mt-2"
             thead-class="Protocolos_table--header"
             tbody-tr-class="thead-row-class"
             show-empty>
      <template #row-details="data">
        <div class="text-left">
          <b-card style="width: 70%">
            <b>Observação:</b><br>
            <protocolo-observacao :prop-log="data.item" />
          </b-card>
        </div>
      </template>
      <template #table-busy>
        <div class="text-center text-info my-2">
          <b-spinner class="align-middle mr-2 icon--sm" />

          <strong>Carregando...</strong>
        </div>
      </template>
      <template v-slot:empty="scope">
        <div class="text-center">
          Sem registros
        </div>
      </template>
      <template slot="key_data_log"
                slot-scope="data">
        <div class="text-center">
          {{ data.item.data_log | dateHour }}
        </div>
      </template>
      <template slot="key_acoes"
                slot-scope="data">
        <div class="text-right">
          <span v-if="!data.item.automatico"
                class="text-center">
            <button class="btn btn-sm btn-outline-danger mr-2"
                    @click="deleteLog(data.item)">
              Excluir
            </button>
          </span>
          <span>
            <button v-if="!data.item.automatico"
                    class="btn btn-sm btn-outline-primary mr-2"
                    @click="editLog(data.item)">
              Editar
            </button>
          </span>
          <span>
            <button v-if="!!data.item.observacao"
                    class="btn btn-sm btn-info active"
                    @click="data.toggleDetails">
              {{ !data.detailsShowing ? 'Mostrar': 'Esconder' }} detalhes
            </button>
          </span>
        </div>
      </template>
    </b-table>
    <!-- protocolo log form -->
    <protocolo-log-form v-if="modalLog.show"
                        :prop-log="modalLog.log"
                        @onSaveProtocolo="(log) => saveLog(log)"
                        @onSaveLog="log => saveLog(log)"
                        @onCloseModal="closeModalLog()" />
  </div>
</template>

<script>
  /* components */
  import ProtocoloLogForm from "@/components/SofiaRei/Protocolos/ProtocoloLogForm"
  import ProtocoloObservacao from "@/components/SofiaRei/Protocolos/ProtocoloObservacao"

  /* services */
  import ProtocolosService from "@/services/Protocolos"
  import ProtocolosLogService from "@/services/Protocolos/ProtocolosLogService"

  export default {
    name: "ProtocoloHistory",
    components: {
      ProtocoloObservacao,
      ProtocoloLogForm
    },
    props: {
      propProtocolo: {
        type: Object,
        default: () => ({})
      },
      show: {type: Boolean, default: false }
    },
    data () {
      return {
        table: {
          busy: false,
          fields: [
            {
              key: 'id',
              label: '#ID',
              sortable: false
            },
            {
              key: 'key_data_log',
              label: 'Data andamento',
              sortable: false
            },
            {
              key: 'responsavel',
              label: 'Responsavel',
              sortable: false
            },
            {
              key: 'status',
              label: 'Status',
              sortable: false
            },
            {
              key: 'key_acoes',
              label: 'Ação',
              sortable: false
            }
          ]
        },
        protocolo: {},
        modalLog: {
          show: false,
          log: {}
        },
      }
    },
    watch: {
      'propProtocolo.id' () {
        this.init()
      }
    },
    created () {
      this.init()
    },
    methods: {
      async init (jump = false) {
        try {
          loader({ active: true, text: 'Carregando protocolo...' })
          if (Object.values(this.propProtocolo).length > 0 && !jump) {
            this.protocolo = { ...this.propProtocolo }
          } else if (!!this.propProtocolo && !!this.propProtocolo.id) {
            this.protocolo = await ProtocolosService.show(this.propProtocolo.id)
          }
        } finally {
          loader({ active: false, text: '' })
        }
      },
      showModalLog () {
        this.modalLog.log = {}
        this.modalLog.show = true
      },
      closeModalLog () {
        this.modalLog.show = false
        this.modalLog.log = {}
      },
      async saveLog (log) {
        log.protocolo_id = this.propProtocolo.id 
        try {
          loader({ active: true, text: 'Salvando andamento...' })

          if (!log.id) {
            await ProtocolosLogService.store(log)
          } else {
            await ProtocolosLogService.update(log.id, log)
          }

          objSwal.success.title = 'Salvo com sucesso!'
          objSwal.success.text = ''
          this.init(true)
          Swal.fire(objSwal.success)
          this.closeModalLog()
        } catch (e) {
          objSwal.success.title = 'Erro ao salvar andamento...'
          console.error(e)
        } finally {
          loader({ active: false, text: '' })
        }
      },
      async deleteLog (log) {
        try {
          objSwal.question.title = `Atenção!`
          objSwal.question.text = `Deseja excluir o andamento #${ log.id }?`
          const status = await Swal.fire(objSwal.question)

          if (status.value) {
            loader({ active: true,  text: 'Apagando andamento...' })
            await ProtocolosLogService.delete(log)
            objSwal.success.title = 'Excluído com sucesso!'
            objSwal.success.text = ''
            Swal.fire(objSwal.success)
            this.init(true)
          }
        } finally {
          loader({ active: false })
        }
      },
      async editLog (log) {
        this.modalLog.log = log
        this.modalLog.show = true
      },
    }
  }

</script>